import React from "react";
import { Outlet } from "react-router";
import { Navigate } from "react-router-dom";
import { User } from "./models/User";
import SignInPage from "./pages/main/auth/sign-in";

interface UserProtectedRoutesAttributes {
  isUser: boolean;
}

const UserProtectedRoutes = (props: UserProtectedRoutesAttributes) => {

  return props.isUser ? <Outlet /> : <Navigate to="/auth/sign-in" />;

  // return (
  //   <Switch>
  //     <Route path="/dashboard" component={Dashboard} />
  //     <Route path="/profile" component={Profile} />
  //   </Switch>
  // );
}

export default UserProtectedRoutes;